// Must be in sync with sharing/AccessLevel.ts
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["NONE"] = 0] = "NONE";
    AccessLevel[AccessLevel["READ_ONLY"] = 10] = "READ_ONLY";
    AccessLevel[AccessLevel["READ_ONLY_CAN_COMMENT"] = 15] = "READ_ONLY_CAN_COMMENT";
    AccessLevel[AccessLevel["READ_WRITE"] = 20] = "READ_WRITE";
    AccessLevel[AccessLevel["READ_WRITE_SHARE"] = 30] = "READ_WRITE_SHARE";
    AccessLevel[AccessLevel["ADMIN"] = 40] = "ADMIN";
    AccessLevel[AccessLevel["OWNER"] = 50] = "OWNER";
})(AccessLevel || (AccessLevel = {}));
// Must be in sync with GridColumnDefEnum.java definitions
export var GridDataType;
(function (GridDataType) {
    GridDataType[GridDataType["CHECKBOX"] = 1] = "CHECKBOX";
    GridDataType[GridDataType["DATE"] = 3] = "DATE";
    GridDataType[GridDataType["DATETIME"] = 4] = "DATETIME";
    GridDataType[GridDataType["NUMBER"] = 5] = "NUMBER";
    GridDataType[GridDataType["PICKLIST"] = 6] = "PICKLIST";
    GridDataType[GridDataType["ABSTRACTDATETIME"] = 7] = "ABSTRACTDATETIME";
    GridDataType[GridDataType["TEXT"] = 9] = "TEXT";
    GridDataType[GridDataType["USERLIST"] = 17] = "USERLIST";
    GridDataType[GridDataType["USERREF"] = 19] = "USERREF";
    GridDataType[GridDataType["DURATION"] = 21] = "DURATION";
    GridDataType[GridDataType["PREDECESSOR"] = 22] = "PREDECESSOR";
    GridDataType[GridDataType["IMAGE"] = 23] = "IMAGE";
    GridDataType[GridDataType["MULTIUSERLIST"] = 24] = "MULTIUSERLIST";
    GridDataType[GridDataType["MULTIPICKLIST"] = 25] = "MULTIPICKLIST"; // Stores an array of Strings
})(GridDataType || (GridDataType = {}));
// Must be in sync with GridColumnDefEnum.java definitions
export var ColumnType;
(function (ColumnType) {
    ColumnType[ColumnType["COLUMNTYPE_TEXTNUMBER"] = 0] = "COLUMNTYPE_TEXTNUMBER";
    ColumnType[ColumnType["COLUMNTYPE_CONTACT"] = 1] = "COLUMNTYPE_CONTACT";
    ColumnType[ColumnType["COLUMNTYPE_DATE"] = 2] = "COLUMNTYPE_DATE";
    ColumnType[ColumnType["COLUMNTYPE_PICKLIST"] = 3] = "COLUMNTYPE_PICKLIST";
    ColumnType[ColumnType["COLUMNTYPE_CHECKBOX"] = 4] = "COLUMNTYPE_CHECKBOX";
    ColumnType[ColumnType["COLUMNTYPE_RYG"] = 5] = "COLUMNTYPE_RYG";
    ColumnType[ColumnType["COLUMNTYPE_HARVEY"] = 6] = "COLUMNTYPE_HARVEY";
    ColumnType[ColumnType["COLUMNTYPE_PRIORITY"] = 7] = "COLUMNTYPE_PRIORITY";
    ColumnType[ColumnType["COLUMNTYPE_STAR"] = 8] = "COLUMNTYPE_STAR";
    ColumnType[ColumnType["COLUMNTYPE_FLAG"] = 9] = "COLUMNTYPE_FLAG";
    ColumnType[ColumnType["COLUMNTYPE_SYS_INSERTBY"] = 10] = "COLUMNTYPE_SYS_INSERTBY";
    ColumnType[ColumnType["COLUMNTYPE_SYS_INSERTDATE"] = 11] = "COLUMNTYPE_SYS_INSERTDATE";
    ColumnType[ColumnType["COLUMNTYPE_SYS_MODIFYBY"] = 12] = "COLUMNTYPE_SYS_MODIFYBY";
    ColumnType[ColumnType["COLUMNTYPE_SYS_MODIFYDATE"] = 13] = "COLUMNTYPE_SYS_MODIFYDATE";
    ColumnType[ColumnType["COLUMNTYPE_SYS_UNIQUEID"] = 14] = "COLUMNTYPE_SYS_UNIQUEID";
    ColumnType[ColumnType["COLUMNTYPE_SYS_SHEETNAME"] = 15] = "COLUMNTYPE_SYS_SHEETNAME";
    ColumnType[ColumnType["COLUMNTYPE_ABSTRACTDATETIME"] = 16] = "COLUMNTYPE_ABSTRACTDATETIME";
    ColumnType[ColumnType["COLUMNTYPE_PRIORITYHML"] = 17] = "COLUMNTYPE_PRIORITYHML";
    ColumnType[ColumnType["COLUMNTYPE_DECISIONSYMBOLS"] = 18] = "COLUMNTYPE_DECISIONSYMBOLS";
    ColumnType[ColumnType["COLUMNTYPE_DECISIONSHAPES"] = 19] = "COLUMNTYPE_DECISIONSHAPES";
    ColumnType[ColumnType["COLUMNTYPE_DECISIONVCR"] = 20] = "COLUMNTYPE_DECISIONVCR";
    ColumnType[ColumnType["COLUMNTYPE_RYGB"] = 21] = "COLUMNTYPE_RYGB";
    ColumnType[ColumnType["COLUMNTYPE_RYGG"] = 22] = "COLUMNTYPE_RYGG";
    ColumnType[ColumnType["COLUMNTYPE_WEATHER"] = 23] = "COLUMNTYPE_WEATHER";
    ColumnType[ColumnType["COLUMNTYPE_PROGRESS5"] = 24] = "COLUMNTYPE_PROGRESS5";
    ColumnType[ColumnType["COLUMNTYPE_ARROWS3"] = 25] = "COLUMNTYPE_ARROWS3";
    ColumnType[ColumnType["COLUMNTYPE_ARROWS4"] = 26] = "COLUMNTYPE_ARROWS4";
    ColumnType[ColumnType["COLUMNTYPE_ARROWS5"] = 27] = "COLUMNTYPE_ARROWS5";
    ColumnType[ColumnType["COLUMNTYPE_DIRECTIONS3"] = 28] = "COLUMNTYPE_DIRECTIONS3";
    ColumnType[ColumnType["COLUMNTYPE_DIRECTIONS4"] = 29] = "COLUMNTYPE_DIRECTIONS4";
    ColumnType[ColumnType["COLUMNTYPE_DIFFICULTY4"] = 30] = "COLUMNTYPE_DIFFICULTY4";
    ColumnType[ColumnType["COLUMNTYPE_SIGNAL5"] = 31] = "COLUMNTYPE_SIGNAL5";
    ColumnType[ColumnType["COLUMNTYPE_STAR6"] = 32] = "COLUMNTYPE_STAR6";
    ColumnType[ColumnType["COLUMNTYPE_HEART6"] = 33] = "COLUMNTYPE_HEART6";
    ColumnType[ColumnType["COLUMNTYPE_MONEY6"] = 34] = "COLUMNTYPE_MONEY6";
    ColumnType[ColumnType["COLUMNTYPE_EFFORT6"] = 35] = "COLUMNTYPE_EFFORT6";
    ColumnType[ColumnType["COLUMNTYPE_PAIN6"] = 36] = "COLUMNTYPE_PAIN6";
    ColumnType[ColumnType["COLUMNTYPE_DURATION"] = 37] = "COLUMNTYPE_DURATION";
    ColumnType[ColumnType["COLUMNTYPE_PREDECESSOR"] = 38] = "COLUMNTYPE_PREDECESSOR";
    ColumnType[ColumnType["COLUMNTYPE_MULTICONTACT"] = 39] = "COLUMNTYPE_MULTICONTACT";
    ColumnType[ColumnType["COLUMNTYPE_MULTIPICKLIST"] = 40] = "COLUMNTYPE_MULTIPICKLIST";
})(ColumnType || (ColumnType = {}));
// Must be in sync with GridColumnDefEnum.java definitions
export var ColumnValidationType;
(function (ColumnValidationType) {
    ColumnValidationType[ColumnValidationType["OFF"] = 0] = "OFF";
    ColumnValidationType[ColumnValidationType["ON"] = 1] = "ON";
})(ColumnValidationType || (ColumnValidationType = {}));
/**
 * @export
 */
export var LegacyDiscussionColumnUpdateType;
(function (LegacyDiscussionColumnUpdateType) {
    LegacyDiscussionColumnUpdateType[LegacyDiscussionColumnUpdateType["COMMENT"] = 0] = "COMMENT";
    LegacyDiscussionColumnUpdateType[LegacyDiscussionColumnUpdateType["DRAFT"] = 1] = "DRAFT";
    LegacyDiscussionColumnUpdateType[LegacyDiscussionColumnUpdateType["UNREAD"] = 2] = "UNREAD";
})(LegacyDiscussionColumnUpdateType || (LegacyDiscussionColumnUpdateType = {}));
//# sourceMappingURL=models.js.map